// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3WmuE","left":"InfoRow_left__3s8Ma"};